import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { withRouter } from "react-router-dom";

import LinkButton from "../components/LinkButton";

import { ToastContainer, toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";

import { createBrowserHistory } from "history";

import { Redirect } from "react-router-dom";

import { useStateWithCallback } from "../utils/useStateWithCallback";

import * as Constants from "./Constants";

const baseUrl = Constants.URL();

function UpdateDetails({ match }) {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const [email, setemail] = React.useState(match.params.email);

  useEffect(() => {
    getSubscription();
  }, []);

  const location = {
    pathname: "/Newsletters",
    state: { fromDashboard: true },
  };

  const history = createBrowserHistory();

  const [post, setPost] = React.useState(null);
  const [subscriptionData, setSubscription] = React.useState(null);
  const [isValid, setIsValid] = useStateWithCallback(true);
  const [urlRedirect, seturlRedirect] = React.useState(null);
  const toastId = React.useRef(null);

  const [toggle, setToggle] = React.useState(false);
  const [invalidEmail, setInvalidEmail] = React.useState(null);

  let showFailedMessage = false;

  var getSubscription = () => {
    var data;
    axios
      .get(`${baseUrl}Subscribe/GetSubscription?email=${email.split("=")[1]}`, {
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      })
      .then((response) => {
        setSubscription(response.data);
      });
  };

  function emailValidation() {
    const regex =
      '/^(([^<>()[].,;:s@"]+(.[^<>()[].,;:s@"]+)*)|(".+"))@(([^<>()[].,;:s@"]+.)+[^<>()[].,;:s@"]{2,})$/i';
    if (!email || regex.test(email) === false) {
      setInvalidEmail("Email is not valid");
      return false;
    }
    return true;
  }

  // const handleChange = (e) => {
  //   setState({
  //     [e.target.name]: e.target.value,
  //   });
  // };

  function onChange(e) {
    setSubscription(e.target.value);
    emailValidation();
  }

  const onSubmit = function (data) {
    var subscription = {
      Id: data.hiddenId,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      active: true,
      organisation: data.organisation,
    };

    axios
      .post(`${baseUrl}Subscribe/Update`, subscription)
      .then((response) => {
        setPost(response.data);

        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.success("Submitted Successfully", {
            toastId: "success",
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });

          history.push(location);

          setTimeout(() => window.location.reload(), 3800);
        }
      })
      .catch((err) => {
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error("Submission failed", {
            toastId: "failed",
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: false,
            draggable: false,
            progress: undefined,
            theme: "light",
          });
        }
      });
  };

  return (
    <div className="Card u-marginAuto u-marginBottom20">
      <div className="Card-content u-marginTop10">
        {subscriptionData ? (
          <form onSubmit={handleSubmit(onSubmit)}>
            <input
              className="customInput"
              type="hidden"
              name="csrfmiddlewaretoken"
              value="0aiY5RDRupxjz3ITP49uNZ3YYfET3oeBn3RewbVyTP1JNRJIwc6YRdCACn9UbrQr"
            />
            <h2 className="Card-title u-marginBottom20">Update your details</h2>
            <p>
              <label htmlFor="email">Email address:</label>
              <input
                className="customInput"
                type="email"
                name="email"
                autoFocus="autoFocus"
                {...register("email", { required: true })}
                id="id_email"
                value={subscriptionData.Email}
                onChange={onChange}
              />
            </p>
            {errors.email && errors.email.type === "required" && (
              <span className="required">Email address is required</span>
            )}
            <p>
              <label htmlFor="id_firstName">First Name:</label>
              <input
                className="customInput"
                type="text"
                name="firstName"
                {...register("firstName", { required: true })}
                id="id_firstName"
                value={subscriptionData.FirstName}
                onChange={onChange}
              />
            </p>
            {errors.firstName && (
              <span className="required">First Name is required</span>
            )}
            <p>
              <label htmlFor="id_lastName">Last Name:</label>
              <input
                className="customInput"
                type="text"
                name="lastName"
                {...register("lastName", { required: true })}
                id="id_lastName"
                value={subscriptionData.LastName}
                onChange={onChange}
              />
            </p>
            {errors.lastName && (
              <span className="required">Last Name is required</span>
            )}
            <p>
              <label htmlFor="id_organisation">
                Organisation / Institution:
              </label>
              <input
                className="customInput"
                type="text"
                name="organisation"
                {...register("organisation", { required: true })}
                id="id_organisation"
                value={subscriptionData.Organisation}
                onChange={onChange}
              />
            </p>
            {errors.organisation && (
              <span className="required">
                Organisation or Institution is required
              </span>
            )}
            <input
              type="Submit"
              className="Button"
              //</form>onClick={handleSubmit(onSubmit)}>

              //</div></button> /
            />
            <input
              type="hidden"
              name="hiddenId"
              {...register("hiddenId", { required: true })}
              id="id_lhiddenId"
              value={subscriptionData.Id}
            />
          </form>
        ) : (
          <h3 className="center">Subscription not found</h3>
        )}
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <ToastContainer />
    </div>
  );
}

//<input className="Button" type="submit" value="Update Profile" />
//<br />
//<input className="Button" type="submit" value="Unsubscribe" />

export default withRouter(UpdateDetails);
